<template>
  <div class="flex">
    <ButtonBase
      :color="props.color"
      :size="props.size"
      rounded="left"
      :leadingIcon="props.leadingIcon"
      @click="emit('click')"
      :href="props.href"
      >{{ props.label }}</ButtonBase
    >
    <MenuButton as="template">
      <button :class="classes">
        <ChevronDownIcon class="h-5 w-5" aria-hidden="true" />
      </button>
    </MenuButton>
  </div>
</template>

<script setup>
import ButtonBase from '../Buttons/ButtonBase.vue'
import { MenuButton } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { useButtonClasses } from '../Buttons/common'

const props = defineProps({
  label: {
    type: String,
  },
  size: {
    type: String,
    default: 'md',
  },
  color: {
    type: String,
    default: 'white',
  },
  leadingIcon: Function,
  href: String,
})

const classes = useButtonClasses({
  ...props,
  size: 'xs',
  shape: 'default',
  rounded: 'right',
})

const emit = defineEmits(['click'])
</script>
